module.exports = __webpack_public_path__ + "img/ja.61ecf7a9.svg";